import { Box } from '@chakra-ui/react';
//
// COMPLETED: ,
// PENDING: { color: '#344054', bg: '#F2F4F7' },
// DRAFT: { color: '#344054', bg: '#F2F4F7' },
// RETURNED: { color: '#FFB323', bg: '#FFEFD7' },
// PROCESSING: { color: '#027A48', bg: '#ECFDF3' },
// PAID: { color: '#027A48', bg: '#027A48' },
// NOT_PAID: { color: '#344054', bg: '#F2F4F7' },
const BadgeStatus = (status) => {
    switch (status) {
        case 'COMPLETED':
        case 'ACCEPTED':
        case 'SHIPPED':
            return { color: '#078D35', bg: '#DCFCE7' };
        case 'PENDING':
            return { color: '#A16207', bg: '#FEF9C3' };
        case 'REJECTED':
        case 'HIGH':
            return { color: '#B71C1C', bg: '#FFCDD2' };
        case 'NOT_STARTED':
            return { color: '#7A6E00', bg: '#FFF9C4' };
        default:
            return { color: '#1D4ED8', bg: '#DBEAFE' };
    }
};

export default function StatusBadge({ status = '', noBg = false }) {
    return (
        <Box
            textTransform="capitalize"
            bg={noBg ? 'transparent' : BadgeStatus(status)?.bg}
            color={BadgeStatus(status)?.color}
            fontSize="sm"
            display="inline-block"
            borderRadius="8px"
            p="3">
            {status?.toLowerCase()}
        </Box>
    );
}
